import {Image} from 'antd';
import styled from 'styled-components';

const AvatarWrapper = styled.div`
  display: inline-block;
  cursor: pointer;
  font-size: 24px;
  font-weight: 800;
  text-align: center;
`;

const ImageWrapper = styled(Image)`
  &&& {
    height: auto;
    width: 55px;
  }
`;

export {AvatarWrapper, ImageWrapper};
